<soft-page>
  <soft-page-header>
    <div class="flex items-center justify-between gap-2 w-full">
      <button
        type="button"
        class="flex flex-col text-start gap-0.5"
        (click)="openDatePicker()"
      >
        <span class="soft-overline">{{ date() | date:'EEEE' }}</span>
        <span class="font-bold hover:underline hover:cursor-pointer">
          {{ date() | date:'dd.MM.yyyy' }}
        </span>
        <span class="text-xs text-light">KW {{ date() | date:'ww' }}</span>
      </button>
      <soft-ds-prev-curr-next-navigation
        (previous)="navigatePrev()"
        (today)="navigateToday()"
        (next)="navigateNext()"
      />
    </div>
  </soft-page-header>
  <soft-time-report-list
    (selectedChange)="navigateToEditPage($event)"
  ></soft-time-report-list>
  <soft-page-footer>
    <div
      class="flex flex-col gap-1 px-4 py-3"
      style="background: var(--ds-surface-base)"
    >
      @if (entryCount() === 0) {
        <div class="flex flex-row justify-between items-center">
          <span class="ds-body-2-semibold">Gesamt</span>
          <span class="ds-body-2 color-light">Keine Einträge</span>
        </div>
      } @else {
        @for (entry of totalTime(); track entry) {
          <div class="flex flex-row justify-between items-center">
            <span class="ds-body-2-semibold">
              {{ entry?.zbewe?.bezeichnung ?? 'Gesamt' }}
            </span>
            <span class="ds-body-2-semibold">
              {{ (entry?.duration ?? null) | format: 'DURATION.DEFAULT' }}
            </span>
          </div>
        }
        <span class="ds-caption color-light">
          {{ entryCount() }} {{ entryCount() === 1 ? 'Eintrag' : 'Einträge' }}
        </span>
      }
    </div>
  </soft-page-footer>
</soft-page>
